<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">


    <sidebar></sidebar>
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row bg-secondary p-2">
        <div class="col-lg-12 bg-white" style="border-radius: 1vw">
          <br>
          <h2 style="font-size: 1.6vw !important; text-align: right">تعریف دوره های چرخه </h2>
          <hr>
          <div class="row p-3 w-100">
            <div class="d-flex flex-column col-3">
              <label for="" class="required">سال دوره چرخه </label>
              <vue3-persian-datetime-picker type="year" simple v-model="name"/>
            </div>


            <div class="col-2" v-if="!is_edit">
              <button @click.prevent="store" class="btn btn-primary btn-submit-1" style="transform: translateY(1.8vw)">
                افزودن
              </button>
            </div>
            <div class="col-2 mx-5" v-else>
              <button @click.prevent="update(id)" class="btn btn-primary btn-submit-1"
                      style="transform: translateY(1.8vw) translateX(3vw)">ویرایش
              </button>
              <Reset @click.prevent="resetAll()" style="width: 2vw;"/>
            </div>
          </div>


          <hr>
          <br>
          <center v-show="!all_items.length" class="mb-5">
            دوره ای برای پایش پایش اقدامات وجود ندارد
          </center>
          <table v-show="all_items.length" class="table table-striped">
            <thead>
            <tr>
              <th style="width: 1vw;">ردیف</th>
              <th>سال دوره چرخه</th>
              <th v-if="false">تاریخ شروع</th>
              <th v-if="false">تاریخ پایان</th>
              <th class="col-2">دوره های پایش</th>
              <th>دسترسی</th>
              <th>وضعیت نهایی</th>
              <th v-if="false" style="width: 4vw;"> عملیات</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in all_items">
              <td scope="row">{{ index + 1 }}</td>
              <td>{{ item.name }}</td>
              <td v-if="false">{{ item.start_date }}</td>
              <td v-if="false">{{ item.end_date }}</td>
              <td style="cursor: pointer">
                <button @click.prevent="allHabits(item.id,item.name)" class="btn btn-primary btn-submit-1 w-100">مشاهده
                  / بروزرسانی
                </button>
              </td>
              <td style="cursor: pointer" @click.prevent="updateComplate2(item.id,item.finish, item.status)">
                {{ item.status ? 'فعال' : 'غیرفعال' }}
              </td>
              <td style="cursor: pointer" @click.prevent="updateComplate(item.id,item.finish, item.status)">
                {{ item.complate }}
              </td>
              <td v-if="false">
                <div v-if="!item.finish" class="d-flex" style="height: 1vw !important;">
                  <p v-if="false" style="width: 2vw;" @click.prevent="deleteMethod(item.id)" href="#"><img
                      class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"></p>
                  <a style="width: 2vw; transform: translateX(-0.2vw)" @click.prevent="edit(item.id)" href="#"><img
                      class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
                </div>
                <div v-else>--</div>
              </td>


            </tr>

            </tbody>
          </table>

        </div>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 55%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="submit_delete">تایید</button>
      </div>
    </div>
  </div>


  <!-- todo! modal -->
  <div dir="rtl" class="modal__error slide-top" v-if="habit_modal"
       style="z-index: 999999999999999999999999999999999999999999999; top: 38%;">
    <div>
      <p>دوره های {{ habit_name }} </p>
      <p @click="habit_modal=!habit_modal">❌</p>
    </div>
    <div>
      <div class="bg-white w-100 p-2 rounded">
        <table v-show="all_habits.length" class="table table-striped">
          <thead>
          <tr>
            <th style="width: 1vw;">ردیف</th>
            <th>عنوان دوره</th>
            <th>هدف</th>
            <th>عملکرد</th>
            <th>نمایش در خروجی <span title="هنگام استفاده از این گزینه فقط دوره جاری در خروجی کاربرگ های 6 - 7 نمایش داده میشود.">ℹ️</span></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item,index) in all_habits">
            <td scope="row">{{ index + 1 }}</td>
            <td>{{ item.name }}</td>
            <td style="cursor: pointer" @click.prevent="updateActiveHabit(item.id)">
              {{ item.active ? 'فعال' : 'غیرفعال' }}
            </td>
            <td style="cursor: pointer" @click.prevent="updateStatusHabit(item.id)">
              {{ item.status_progress ? 'فعال' : 'غیرفعال' }}
            </td>
            <td style="cursor: pointer" @click.prevent="updatePrintHabit(item.id)">
              {{ item.is_print ? 'فعال' : 'غیرفعال' }}
            </td>

          </tr>

          </tbody>
        </table>
      </div>


      <button @click="habit_modal=!habit_modal">بازگشت</button>
    </div>
  </div>
</template>
<script>
import Sidebar from "@/components/Sidebar/Sidebar.vue";
import Splash from "@/components/Splash/Splash.vue";
import {useToast} from "vue-toastification";
import Reset from "@/components/Icons/Reset.vue";
import router from "@/router";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'

const toast = useToast();

export default {
  components: {Reset, Splash, Sidebar, Vue3PersianDatetimePicker},
  data() {
    return {
      habit_modal: false,
      all_habits: [],
      all_items: [],
      habit_name: '',
      name: '',
      start_date: '',
      end_date: '',
      status: '',
      id: '',
      id_delete: '',
      deleteModal: false,
      is_edit: false,
    }
  },
  methods: {
    allHabits(id, habit_name=null) {
      if (habit_name!== null) {
        this.habit_name = habit_name

      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/habits/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            if (response.all) {
              this.all_habits.length = 0
              response.all.forEach((ele) => {
                this.all_habits.push(ele)
              })
              this.habit_modal = true
            }

          })
          .catch();
    },
    updateActiveHabit(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/change_status_habits/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            if (response.message) {
              toast.success(response.message)
              this.allHabits(response.id)
            }

          })
          .catch();
    },updateStatusHabit(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/change_status_progress_habits/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            if (response.message) {
              toast.success(response.message)
              this.allHabits(response.id)
            }

          })
          .catch();
    },updatePrintHabit(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/change_status_print_habits/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            if (response.message) {
              toast.success(response.message)
              this.allHabits(response.id)
            }

          })
          .catch();
    },
    resetItem() {
      this.name = ''
      this.id = ''
    },
    store() {
      if (!this.name) {
        toast.error('دوره پایش اقدامات اجباری است!')
        return false;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('name', this.name)
      formdata.append('start_date', this.start_date)
      formdata.append('end_date', this.end_date)
      formdata.append('status', '0')


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            if (response.message) {
              toast.success(response.message)
              this.name = ''
              this.id = ''
              this.start_date = ''
              this.end_date = ''
              this.status = ''
              this.all()
            }

          })
          .catch();
    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return;
            }
            if (response.all) {
              this.all_items.length = 0
              response.all.forEach((ele) => {
                this.all_items.push(ele)
              })
            }

          })
          .catch();
    },
    edit(id) {

      this.id = id
      this.is_edit = true

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
            }
            if (response.item) {
              this.name = response.item.name
              this.start_date = response.item.start_date
              this.end_date = response.item.end_date
              this.status = response.item.status
            }

          })
          .catch();
    },
    resetAll() {
      this.name = ''
      this.start_date = ''
      this.end_date = ''
      this.is_edit = false
      this.status = ''
    },

    update(id) {
      if (!this.name) {
        toast.error('دوره پایش اقدامات اجباری است!')
        return false;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('name', this.name)
      formdata.append('start_date', this.start_date)
      formdata.append('end_date', this.end_date)
      formdata.append('status', this.status)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
            }
            if (response.message) {
              toast.success(response.message)
              this.is_edit = false
              this.all()
              this.resetAll()

            }

          })
          .catch();
    },
    updateComplate(id, finish, status) {
      if (finish || !status) {
        if (!finish) {
          toast.error('امکان تغییر وضعیت برای دوره های غیرفعال وجود ندارد!')
          return;
        }
        toast.error('امکان تغییر وضعیت برای دوره های تکمیل شده وجود ندارد!')
        return;
      }
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('complate', 1)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
            }
            if (response.message) {
              toast.success(response.message)
              this.all()

            }

          })
          .catch();
    },
    updateComplate2(id, finish, status) {

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('status', 1)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
            }
            if (response.message) {
              toast.success(response.message)
              this.all()

            }

          })
          .catch();
    },
    submit_delete() {
      if (!this.id_delete) return;
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/ProductivityPeriod/destroy/${this.id_delete}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
            }
            if (response.message) {
              toast.success(response.message)
              this.id_delete = ''
              this.deleteModal = false
              this.all()
            }

          })
          .catch();
    },
    deleteMethod(id) {
      this.id_delete = id
      this.deleteModal = true
    },
    checkIsMother() {
      if (!this.is_mother) {
        router.push('/pishkhan')
        return
      }
      this.all()

    }
  },
  mounted() {
    this.checkIsMother()


  }

}
</script>
<style scoped>

</style>